import script from "./StaffInfoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./StaffInfoView.vue?vue&type=script&lang=ts&setup=true"

import "./StaffInfoView.vue?vue&type=style&index=0&id=cee282ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cee282ce"]])

export default __exports__